export default "__VITE_ASSET__B$reRMOB__"